export default __webpack_public_path__ + "static/media/icon-instagram.9b638fbf.svg";